import type { MaybeRefOrGetter } from 'vue'

export const useCallDetailsRightPanelClass = (open: MaybeRefOrGetter<boolean>) =>
  computed(() => ['w-[600px]', toValue(open) ? 'right-4' : ''].filter(Boolean).join(' '))
